export const DateStr = (d: Date) => {
  const yyyy = d.getFullYear();
  const MM = `${d.getMonth() + 1}`.padStart(2, "0");
  const dd = `${d.getDate()}`.padStart(2, "0");

  return `${yyyy}-${MM}-${dd}`;
};
